import { Box, Button, Grid, Typography } from "@material-ui/core";
import {
  AccountBalance,
  Assessment,
  CloudDownload,
  // Info,
  // Store,
  LocationOn,
  MonetizationOn,
  Payment,
  // Sports,
  People,
  TrendingUp,
} from "@material-ui/icons";
import React, { Component } from "react";

// Import the required components
import ExchangeRatesContainer from "./ExchangeRatesContainer";
import NumUsersContainer from "./NumUsersContainer";
import SignupsTableContainer from "./SignupsTableContainer";
import SubscriptionsContainer from "./SubscriptionsContainer";
import UpgradeInsightsDashboard from "./UpgradesInsights";
// import MollieAuthsContainer from "./MollieAuthsContainer";
// import TournamentSportsContainer from "./TournamentListContainer";
import TournamentExportContainer from "./TournamentExportContainer";
// import ExportUpgradesUIDs from "./ExportUpgradesUIDs";
import DormantUpgradeUsersExportContainer from "./DormantUpgradeUsersExportContainer";
import SubscriptionUpsellExportContainer from "./SubscriptionUpsellExportContainer";
import UpgradeAddressesContainer from "./UpgradeAddressesContainer";

class ReportsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReport: null,
    };
  }

  handleReportClick = (reportKey) => {
    this.setState({ selectedReport: reportKey });
  };

  renderReportContent = () => {
    const { selectedReport } = this.state;
    const { admins } = this.props;

    switch (selectedReport) {
      case "subscriptions":
        return <SubscriptionsContainer admins={admins} />;
      case "signups":
        return <SignupsTableContainer admins={admins} />;
      case "exchangeRates":
        return <ExchangeRatesContainer />;
      case "numUsers":
        return <NumUsersContainer />;
      case "upgradeInsights":
        return <UpgradeInsightsDashboard />;
      // case "mollieAuths":
      //   return <MollieAuthsContainer />;
      // case "sports":
      //   return <TournamentSportsContainer />;
      case "tournamentExport":
        return <TournamentExportContainer />;
      // case "exportUpgradeUIDs":
      //   return <ExportUpgradesUIDs />;
      case "upgradeAddresses":
        return <UpgradeAddressesContainer />;
      case "dormantUpgradeUsers":
        return <DormantUpgradeUsersExportContainer />;
      case "subscriptionUpsell":
        return <SubscriptionUpsellExportContainer />;
      default:
        return null;
    }
  };

  render() {
    const { selectedReport } = this.state;

    const reports = [
      {
        key: "subscriptions",
        title: "Subscriptions",
        subtitle: "View all users that have an active subscription",
        icon: <Payment />,
        color: "#4CAF50",
      },
      {
        key: "signups",
        title: "Signups",
        subtitle: "See the 100 latest tournament signups (registrations)",
        icon: <People />,
        color: "#2196F3",
      },
      {
        key: "exchangeRates",
        title: "Exchange Rates",
        subtitle:
          "See a list of currency exchange rates for international payments",
        icon: <AccountBalance />,
        color: "#FF9800",
      },
      {
        key: "numUsers",
        title: "User Statistics",
        subtitle:
          "View the number of new accounts that are created each year (limited to 1000 for performance)",
        icon: <Assessment />,
        color: "#9C27B0",
      },
      {
        key: "upgradeInsights",
        title: "Upgrade Analytics",
        subtitle:
          "Analyze number of upgrades and revenue for each month and year",
        icon: <TrendingUp />,
        color: "#00BCD4",
      },
      // {
      //   key: "mollieAuths",
      //   title: "Mollie Authorizations",
      //   subtitle: "Manage Mollie payment gateway authorizations",
      //   icon: <Store />,
      //   color: "#607D8B",
      // },
      // {
      //   key: "sports",
      //   title: "Sports Management",
      //   subtitle: "View and manage tournament sports categories",
      //   icon: <Sports />,
      //   color: "#E91E63",
      // },
      // {
      //   key: "tournamentInsights",
      //   title: "Tournament Analytics",
      //   subtitle: "Detailed analytics and insights for tournament data",
      //   icon: <Info />,
      //   color: "#3F51B5",
      // },
      {
        key: "tournamentExport",
        title: "Tournament Export",
        subtitle: "Export all data of upgraded and finished tournaments to CSV",
        icon: <CloudDownload />,
        color: "#FF5722",
      },
      // {
      //   key: "exportUpgradeUIDs",
      //   title: "Export Upgrade UIDs",
      //   subtitle: "Export user IDs for upgrade tracking and analysis",
      //   icon: <CloudDownload />,
      //   color: "#8BC34A",
      // },
      {
        key: "upgradeAddresses",
        title: "Upgrade Addresses",
        subtitle:
          "Export the addresses of all users that have upgraded in a specific year",
        icon: <LocationOn />,
        color: "#FFC107",
      },
      {
        key: "dormantUpgradeUsers",
        title: "Dormant Upgrade Users",
        subtitle:
          "Export users with paid upgrades in a specific period and no newer paid upgrade",
        icon: <CloudDownload />,
        color: "#795548",
      },
      {
        key: "subscriptionUpsell",
        title: "Subscription Upsell",
        subtitle:
          "Export users with multiple paid upgrades within a given period to convert them to a yearly subscription",
        icon: <MonetizationOn />,
        color: "#00897B",
      },
    ];

    if (selectedReport) {
      return (
        <div
          style={{
            padding: "0 24px 24px 24px",
            backgroundColor: "transparent",
          }}
        >
          <Box mb={3}>
            <Button
              variant="outlined"
              onClick={() => this.setState({ selectedReport: null })}
              style={{ marginBottom: 16 }}
            >
              ← Back to Reports
            </Button>
          </Box>
          {this.renderReportContent()}
        </div>
      );
    }

    return (
      <div
        style={{ padding: "0 24px 24px 24px", backgroundColor: "transparent" }}
      >
        <Grid container spacing={3} style={{ marginTop: 16 }}>
          {reports.map((report) => (
            <Grid item xs={12} sm={6} md={4} key={report.key}>
              <div
                style={{
                  height: "100%",
                  cursor: "pointer",
                  padding: 16,
                  border: "1px solid #e0e0e0",
                  borderRadius: 4,
                  backgroundColor: "white",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                }}
                onClick={() => this.handleReportClick(report.key)}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  mb={2}
                  color={report.color}
                >
                  {report.icon}
                  <Typography
                    variant="h6"
                    style={{ marginLeft: 8, color: report.color }}
                  >
                    {report.title}
                  </Typography>
                </Box>
                <Typography variant="body2" color="textSecondary">
                  {report.subtitle}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}

export default ReportsContainer;
